<template>
  <div>
    <div v-show="page1">
      <img
        class="bg"
        src="../assets/03/background/background.png"
      />
      <img
        style="position:absolute;left:10vw;top:75.5vw;width:80vw;"
        src="../assets/03/content/content-01.png"
      />
      <img
        style="position:absolute;left:10vw;top:104vw;width:80vw;"
        src="../assets/03/content/content-02.png"
      />
      <img
        v-show="this.vrindex + 1 < this.vr.length - 2"
        style="position:absolute;right:3vw;top:90vw;width:4.5vw;"
        src="../assets/03/icon/icon-01.png"
        @click="NaviPage(true, true)"
      />
      <img
        v-show="this.vrindex - 1 >= 0"
        style="position:absolute;left:4vw;top:90vw;width:4.5vw;"
        src="../assets/03/icon/icon-02.png"
        @click="NaviPage(false, true)"
      />
      <img
        v-show="this.normalindex + 1 < this.normal.length - 2"
        style="position:absolute;right:3vw;top:118vw;width:4.5vw;"
        src="../assets/03/icon/icon-01.png"
        @click="NaviPage(true, false)"
      />
      <img
        v-show="this.normalindex - 1 >= 0"
        style="position:absolute;left:4vw;top:118vw;width:4.5vw;"
        src="../assets/03/icon/icon-02.png"
        @click="NaviPage(false, false)"
      />
      <img
        style="position:absolute;right:40vw;top:133vw;width:20vw;"
        src="../assets/03/icon/icon-03.png"
      />
      <div style="position:absolute;left:0vw;top:83vw;">
        <img
          style="position:absolute;left:11vw;width:24vw;"
          :src="vr[vrindex]"
          @click="ShowVideo(vrindex)"
        />
        <img
          style="position:absolute;left:38vw;width:24vw;"
          :src="vr[vrindex + 1]"
          @click="ShowVideo(vrindex + 1)"
        />
        <img
          style="position:absolute;left:65vw;width:24vw;"
          :src="vr[vrindex + 2]"
          @click="ShowVideo(vrindex + 2)"
        />
      </div>
      <div style="position:absolute;left:0vw;top:112vw;">
        <img
          style="position:absolute;left:11vw;width:24vw;"
          :src="normal[normalindex]"
          @click="ShowNormalVideo(normalindex)"
        />
        <img
          style="position:absolute;left:38vw;width:24vw;"
          :src="normal[normalindex + 1]"
          @click="ShowNormalVideo(normalindex + 1)"
        />
        <img
          style="position:absolute;left:65vw;width:24vw;"
          :src="normal[normalindex + 2]"
          @click="ShowNormalVideo(normalindex + 2)"
        />
      </div>
    </div>
    <div v-if="page2">
      <img
        class="bg"
        src="../assets/03/background/background.png"
      />
      <videoPlayer
        :playsinline="true"
        ref="videoPlayer"
        :options="playerOptions"
        style="position:absolute;left:10vw;top:75vw;width:80vw;height:80vw;"
        width="80vw"
        height="80vw"
        v-if="!isvr"
      >      
      </videoPlayer>
      
      <Pano v-if="isvr" style="position:absolute;left:10vw;top:75vw;width:80vw;height:45vw;" type='video' :source="vrsource"></Pano>
      <img
        style="position:absolute;top:133vw;left:30vw;width:20vw;"
        src="../assets/03/icon/icon-03.png"
        @click="ShowPage1()"
      />
      <img
        style="position:absolute;top:133vw;left:51vw;width:20vw;"
        src="../assets/03/icon/icon-04.png"
        @click="ShowPage1()"
      />
    </div>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import { Pano } from 'vuejs-vr'
export default {
  
  components: {
    videoPlayer,
    Pano
  },
  data() {
    return {
      playerOptions: {
        muted: false,
        aspectRatio: "16:9",
        inactivityTimeout: 0,
        controls: true,
        sources: [
          {
            type: "video/mp4",
            src: "",
          },
        ],
        controlBar: {
          fullscreenToggle: true,
          durationDisplay: true,
          progressControl: true,
          remainingTimeDisplay: false,
          volumeMenuButton: true,
          volumePanel: true,
        },
      },
      isvr: false,
      page1: true,
      page2: false,
      vrindex: 0,
      vrsource:"",
      normalindex: 0,
      vr: [
        require("../assets/03/video/thumb/01.png"),
        require("../assets/03/video/thumb/02.png"),
        require("../assets/03/video/thumb/03.png"),
        require("../assets/03/video/thumb/04.png"),
        require("../assets/03/video/thumb/05.png"),
        require("../assets/03/video/thumb/06.png"),
        require("../assets/03/video/thumb/07.png"),
        require("../assets/03/video/thumb/08.png"),
        require("../assets/03/video/thumb/09.png"),
        require("../assets/03/video/thumb/10.png"),
        require("../assets/03/video/thumb/11.png"),
        require("../assets/03/video/thumb/12.png"),
        require("../assets/03/video/thumb/13.png"),
        require("../assets/03/video/thumb/14.png"),
        require("../assets/03/video/thumb/15.png"),
        require("../assets/03/video/thumb/16.png"),
        require("../assets/03/video/thumb/17.png"),
        require("../assets/03/video/thumb/18.png"),
        require("../assets/03/video/thumb/19.png"),
        require("../assets/03/video/thumb/20.png"),
        require("../assets/03/video/thumb/21.png")        
      ],
      normal: [
        require("../assets/03/video/thumb/n01.png"),
        require("../assets/03/video/thumb/n02.png"),
        require("../assets/03/video/thumb/n03.png"),
        require("../assets/03/video/thumb/n04.png"),
        require("../assets/03/video/thumb/n05.png"),
        require("../assets/03/video/thumb/n06.png"),
        require("../assets/03/video/thumb/n07.png"),
        require("../assets/03/video/thumb/n08.png"),
        require("../assets/03/video/thumb/n09.png"),
        require("../assets/03/video/thumb/n10.png"),
        require("../assets/03/video/thumb/n11.png"),
        require("../assets/03/video/thumb/n12.png"),
        require("../assets/03/video/thumb/n13.png"),
        require("../assets/03/video/thumb/n14.png"),
        require("../assets/03/video/thumb/n15.png"),
        require("../assets/03/video/thumb/n16.png"),
        require("../assets/03/video/thumb/n17.png"),
      ],
      vrvideo: [
        require("../assets/03/video/vr/01.mp4"),
        require("../assets/03/video/vr/02.mp4"),
        require("../assets/03/video/vr/03.mp4"),
        require("../assets/03/video/vr/04.mp4"),
        require("../assets/03/video/vr/05.mp4"),
        require("../assets/03/video/vr/06.mp4"),
        require("../assets/03/video/vr/07.mp4"),
        require("../assets/03/video/vr/08.mp4"),
        require("../assets/03/video/vr/09.mp4"),
        require("../assets/03/video/vr/10.mp4"),
        require("../assets/03/video/vr/11.mp4"),
        require("../assets/03/video/vr/12.mp4"),
        require("../assets/03/video/vr/13.mp4"),
        require("../assets/03/video/vr/14.mp4"),
        require("../assets/03/video/vr/15.mp4"),
        require("../assets/03/video/vr/16.mp4"),
        require("../assets/03/video/vr/17.mp4"),
        require("../assets/03/video/vr/18.mp4"),
        require("../assets/03/video/vr/19.mp4"),
        require("../assets/03/video/vr/20.mp4"),
        require("../assets/03/video/vr/21.mp4"),
      ],
      normalvideo: [
        require("../assets/03/video/normal/n01.mp4"),
        require("../assets/03/video/normal/n02.mp4"),
        require("../assets/03/video/normal/n03.mp4"),
        require("../assets/03/video/normal/n04.mp4"),
        require("../assets/03/video/normal/n05.mp4"),
        require("../assets/03/video/normal/n06.mp4"),
        require("../assets/03/video/normal/n07.mp4"),
        require("../assets/03/video/normal/n08.mp4"),
        require("../assets/03/video/normal/n09.mp4"),
        require("../assets/03/video/normal/n10.mp4"),
        require("../assets/03/video/normal/n11.mp4"),
        require("../assets/03/video/normal/n12.mp4"),
        require("../assets/03/video/normal/n13.mp4"),
        require("../assets/03/video/normal/n14.mp4"),
        require("../assets/03/video/normal/n15.mp4"),
        require("../assets/03/video/normal/n16.mp4"),
        require("../assets/03/video/normal/n17.mp4"),
      ],
    };
  },
  mounted() {},
  methods: {
    NaviPage(isnext, isvr) {
      if (isvr) {
        if (isnext) {
          if (this.vrindex + 1 < this.vr.length - 2) {
            this.vrindex++;
          }
        } else {
          if (this.vrindex - 1 >= 0) {
            this.vrindex--;
          }
        }
      } else {
        if (isnext) {
          if (this.normalindex + 1 < this.normal.length - 2) {
            this.normalindex++;
          }
        } else {
          if (this.normalindex - 1 >= 0) {
            this.normalindex--;
          }
        }
      }
    },
    ShowVideo(index) {      
      this.vrsource = this.vrvideo[index];      
      this.isvr = true;            
      this.page1 = false;
      this.page2 = true;
    },
    ShowNormalVideo(index) {
      this.isvr = false;
      this.playerOptions.sources[0].src = this.normalvideo[index];      
      this.page1 = false;
      this.page2 = true;
    },
    ShowPage1() {
      this.page1 = true;
      this.page2 = false;
    },
  },
};
</script>
<style scoped>
.bg {
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100vw;
  max-width: 100vw;
}
.checkbox {
  position: absolute;
  width: 1.2vw;
  height: 1.2vw;
  z-index: 2;
}
.hrgrid {
  height: auto;
  width: 90vw;
  display: grid;
  justify-items: center;
}
.vtgrid {
  height: auto;
  width: auto;
  display: grid;
  justify-items: center;
}
</style>
